import React, { Dispatch, SetStateAction } from 'react';

const MIN_PASSWORD_LENGTH = 6;

type Passwords = {
  password1: string;
  password2: string;
  setPassword1: Dispatch<SetStateAction<string>>;
  setPassword2: Dispatch<SetStateAction<string>>;
  isMatching: boolean | undefined;
  isValid: boolean | undefined;
};

export default function useValidatedPasswords(): Passwords {
  const [password1, setPassword1] = React.useState('');
  const [password2, setPassword2] = React.useState('');

  const isMatching = password1.length === 0 || password2.length === 0 ? undefined : password1 === password2;
  const isValid = password1.length === 0 ? undefined : password1.length >= MIN_PASSWORD_LENGTH;

  return { password1, setPassword1, password2, setPassword2, isMatching, isValid };
}
